/* ============================================================
   HELDENA · Versandkosten-Fortschritt mit Lieferwagen

   >>> SCHWELLE HIER AENDERN (in Cent). 3990 = 39,90 EUR <<<
   >>> VERSANDKOSTEN unten bei VERSANDPREIS aendern        <<<
   ============================================================ */
(function () {
  'use strict';

  var SCHWELLE = 3990;
  var VERSANDPREIS = '4,90 \u20AC';
  var STYLE_ID = 'hd-versand-style';
  var BOX_CLASS = 'hd-versand';

  var CSS = [
    '.hd-versand{--hd-track:#EDE4DA;--hd-fill1:#D2854F;--hd-fill2:#A24E24;--hd-ink:#3A322B;--hd-gruen:#2D6A4F;',
    'margin:0 0 18px;padding:15px 17px 18px;background:#FCF8F3;border:1px solid #E9DDD1;border-radius:14px;',
    "font-family:inherit;color:var(--hd-ink);animation:hd-fade .35s ease both}",
    '.hd-versand__text{margin:0 0 15px;font-size:14.5px;line-height:1.45;letter-spacing:.01em}',
    '.hd-versand__text strong{font-weight:650}',
    '.hd-versand--frei{background:#F1F8F4;border-color:#CFE5D9}',
    '.hd-versand--frei .hd-versand__text{color:var(--hd-gruen)}',
    '.hd-versand__bahn{position:relative;height:9px;background:var(--hd-track);border-radius:99px;margin:0 34px 0 0;overflow:visible}',
    '.hd-versand__bahn::before{content:"";position:absolute;inset:0;border-radius:99px;z-index:0;',
    'background:repeating-linear-gradient(90deg,rgba(255,255,255,.75) 0 5px,transparent 5px 12px)}',
    '.hd-versand__fuell{position:absolute;inset:0 auto 0 0;z-index:1;border-radius:99px;',
    'background:linear-gradient(90deg,var(--hd-fill1),var(--hd-fill2));',
    'box-shadow:0 1px 3px rgba(162,78,36,.28);transition:width .7s cubic-bezier(.4,0,.2,1)}',
    '.hd-versand--frei .hd-versand__fuell{background:linear-gradient(90deg,#57A183,var(--hd-gruen));box-shadow:0 1px 3px rgba(45,106,79,.28)}',
    '.hd-versand__lkw{position:absolute;top:50%;z-index:3;color:var(--hd-fill2);',
    'transform:translate(-50%,-50%);transition:left .7s cubic-bezier(.4,0,.2,1);will-change:left;',
    'filter:drop-shadow(0 1px 2px rgba(58,50,43,.22))}',
    '.hd-versand__lkw svg{display:block;animation:hd-fahrt 1.1s ease-in-out infinite}',
    '.hd-versand--frei .hd-versand__lkw{color:var(--hd-gruen)}',
    '.hd-versand--frei .hd-versand__lkw svg{animation:hd-ankunft .8s cubic-bezier(.34,1.56,.64,1) both}',
    '.hd-versand__ziel{position:absolute;right:-30px;top:50%;z-index:2;transform:translateY(-50%);color:#BCA692;line-height:0}',
    '.hd-versand--frei .hd-versand__ziel{color:var(--hd-gruen);animation:hd-puls 1.4s ease-out 1}',
    '.hd-versand__hinweis{margin:13px 0 0;font-size:12.5px;color:#8B7E70;letter-spacing:.01em}',
    '.hd-versand--frei .hd-versand__hinweis{color:#5E8A74}',
    '@keyframes hd-fahrt{0%,100%{transform:translateY(0)}50%{transform:translateY(-1.5px)}}',
    '@keyframes hd-ankunft{0%{transform:scale(1)}40%{transform:scale(1.18) rotate(-3deg)}100%{transform:scale(1)}}',
    '@keyframes hd-puls{0%{transform:translateY(-50%) scale(1)}45%{transform:translateY(-50%) scale(1.3)}100%{transform:translateY(-50%) scale(1)}}',
    '@keyframes hd-fade{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}',
    '@media (prefers-reduced-motion:reduce){.hd-versand,.hd-versand *{animation:none!important;transition:none!important}}'
  ].join('');

  var LKW = '<svg viewBox="0 0 40 24" width="32" height="19" aria-hidden="true" focusable="false">' +
    '<rect x="1" y="4" width="20" height="13" rx="2.5" fill="currentColor"/>' +
    '<path d="M22 8h7.4c.5 0 .97.24 1.26.65L34.6 13.3c.26.36.4.8.4 1.25V16c0 .55-.45 1-1 1H22V8z" fill="currentColor" opacity=".72"/>' +
    '<circle cx="8.5" cy="18.5" r="3.4" fill="#2B2A27"/><circle cx="8.5" cy="18.5" r="1.3" fill="#FCF8F3"/>' +
    '<circle cx="28" cy="18.5" r="3.4" fill="#2B2A27"/><circle cx="28" cy="18.5" r="1.3" fill="#FCF8F3"/></svg>';

  var HAUS = '<svg viewBox="0 0 20 20" width="17" height="17" aria-hidden="true" focusable="false">' +
    '<path d="M10 2.2 1.6 8.1V18h6.1v-5.4h4.6V18h6.1V8.1z" fill="currentColor"/></svg>';

  function euro(cent) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
    } catch (e) {
      return (cent / 100).toFixed(2).replace('.', ',') + ' \u20AC';
    }
  }

  function css() {
    var alt = document.getElementById(STYLE_ID);
    if (alt) alt.remove();
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function html(total) {
    var fehlt = SCHWELLE - total;
    var frei = fehlt <= 0;
    var pct = Math.max(5, Math.min(100, (total / SCHWELLE) * 100));
    var text = frei
      ? 'Gl\u00FCckwunsch! Deine Bestellung wird <strong>kostenlos versendet</strong>. \uD83C\uDF89'
      : 'Nur noch <strong>' + euro(fehlt) + '</strong> bis zum <strong>kostenlosen Versand</strong>.';
    var hinweis = frei
      ? 'Versand innerhalb Deutschlands \u00B7 Lieferzeit 3\u20135 Werktage'
      : 'Kostenloser Versand ab ' + euro(SCHWELLE) + ' \u00B7 sonst ' + VERSANDPREIS;

    return '<div class="' + BOX_CLASS + (frei ? ' hd-versand--frei' : '') + '" role="status" aria-live="polite">' +
      '<p class="hd-versand__text">' + text + '</p>' +
      '<div class="hd-versand__bahn">' +
      '<div class="hd-versand__fuell" style="width:' + pct + '%"></div>' +
      '<span class="hd-versand__lkw" style="left:' + pct + '%">' + LKW + '</span>' +
      '<span class="hd-versand__ziel">' + HAUS + '</span>' +
      '</div>' +
      '<p class="hd-versand__hinweis">' + hinweis + '</p>' +
      '</div>';
  }

  function stellen(total, leer) {
    css();

    var punkte = [];
    var drawer = document.querySelector('#CartDrawer .drawer__inner');
    if (drawer) punkte.push({ wurzel: drawer, vor: drawer.querySelector('cart-drawer-items') });

    var seite = document.querySelector('.cart__footer') || document.querySelector('#main-cart-footer');
    if (seite && seite.parentNode) punkte.push({ wurzel: seite.parentNode, vor: seite });

    punkte.forEach(function (p) {
      if (!p.vor) return;
      var alt = p.wurzel.querySelector(':scope > .' + BOX_CLASS);
      if (alt) alt.remove();
      if (leer) return;
      var huelle = document.createElement('div');
      huelle.innerHTML = html(total);
      p.wurzel.insertBefore(huelle.firstChild, p.vor);
    });
  }

  var laeuft = false;
  function aktualisieren() {
    if (laeuft) return;
    laeuft = true;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { stellen(c.total_price, c.item_count === 0); })
      .catch(function () {})
      .then(function () { laeuft = false; });
  }

  var timer;
  function anstossen() {
    clearTimeout(timer);
    timer = setTimeout(aktualisieren, 180);
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var pfad = typeof url === 'string' ? url : (url && url.url) || '';
    var ergebnis = originalFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(pfad)) ergebnis.then(anstossen, function () {});
    return ergebnis;
  };

  document.addEventListener('DOMContentLoaded', aktualisieren);
  if (document.readyState !== 'loading') aktualisieren();

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-remove-button, .quantity__button, #cart-icon-bubble')) anstossen();
  }, true);

  var beobachter = new MutationObserver(function () { anstossen(); });
  document.addEventListener('DOMContentLoaded', function () {
    var d = document.getElementById('CartDrawer');
    if (d) beobachter.observe(d, { childList: true, subtree: false });
    var j = document.querySelector('.js-contents');
    if (j && j.parentNode) beobachter.observe(j.parentNode, { childList: true });
  });
})();
